/**
 * Grouped navigation for Neon Alpha.
 *
 * Item flags:
 *   requiresAuth — hidden behind login (drives users to /auth via the lock)
 *   requiresPro  — Pro tier paywall (renders a lock icon in the nav; clicking
 *                  the route lands them on the <ProGate> paywall page)
 *   highlight    — marks an item as "new" in the dropdown
 *
 * Free-accessible (unlocked) routes are explicitly:
 *   Dashboard · Paper · Ebooks · News · Get Pro
 * Everything else in this file is Pro-locked.
 */
export const NAV_GROUPS = [
  {
    label: 'Trade',
    items: [
      { name: 'Dashboard', path: '/dashboard', desc: 'Snapshot of your watchlist' },
      { name: 'Paper', path: '/paper', desc: 'Risk-free practice trading' },
      { name: 'Screener', path: '/screener', desc: 'Filter stocks by 30+ criteria', requiresPro: true },
      { name: 'Research', path: '/research', desc: 'Deep fundamentals + AI memo', requiresPro: true },
      { name: 'Chart Analyzer', path: '/chart-analyzer', desc: 'AI trade ideas from any chart', requiresPro: true, highlight: true },
      { name: 'Backtest', path: '/backtest', desc: 'Run a strategy against history', requiresPro: true },
      { name: 'Alerts', path: '/alerts', desc: 'Price + volume notifications', requiresPro: true },
      { name: 'Journal', path: '/journal', desc: 'Track trades & P&L', requiresPro: true },
    ],
  },
  {
    label: 'Learn',
    items: [
      { name: 'Courses', path: '/courses', desc: 'AI-built study paths', requiresPro: true, highlight: true },
      { name: 'Ebooks', path: '/ebooks', desc: 'Curated investing library' },
      { name: 'News', path: '/news', desc: 'Real-time market intel' },
    ],
  },
  {
    label: 'Club',
    items: [
      { name: 'Marketplace', path: '/marketplace', desc: 'Strategies shared by members', requiresPro: true },
      { name: 'Community', path: '/community', desc: 'Discord, Circle, Telegram', requiresPro: true },
    ],
  },
];

export const FLAT_NAV_ITEMS = NAV_GROUPS.flatMap((g) =>
  g.items.map((i) => ({
    name: i.name,
    path: i.path,
    requiresAuth: i.requiresAuth,
    requiresPro: i.requiresPro,
    group: g.label,
  })),
);

export const NAV_TOP_LEVEL = [{ name: 'Get Pro', path: '/pro-access' }];

// Legacy export for any older imports.
export const NAV_ITEMS = [...FLAT_NAV_ITEMS, ...NAV_TOP_LEVEL];
